import { ActionsCell } from "../../../../../Component/Common/Components/DataTable/ActionsCell";
import { DefaultCell } from "../../../../../Component/Common/Components/DataTable/DefaultCell";
import { EEMonitoringProgress } from "../../../../../Component/Model/Dto/EmploymentEquity/Plan/EEMonitoringProgress";
import { ActionType, TableColumn } from "../../../../../Component/Model/Table/Table";
import { DataTableHtmlFormatter } from "../../../../../Component/Model/helpers";
interface MonitoringProgressRow {
    Id: string;
    Stakeholder: string;
    Responsibility: string;
    Frequency: string;
    SourceScorecard: React.ReactNode;
    Actions?: ActionType[];
}

export interface MonitoringProgressTable {
    columns: Array<TableColumn>;
    rows: Array<MonitoringProgressRow>;
}

export function MonitoringProgressTableMapper(dataObject: EEMonitoringProgress.DtoIn[], 
    handleEdit: (id: string) => void, 
    handleDelete: (id: string) => void,
    isConsolidated: boolean) : 
    MonitoringProgressTable {
    const columns = [
        {Header: 'Stakeholder', accessor: 'Stakeholder', Cell: ({value}: any) => <DefaultCell value = {value} tooltip = {true}/> },
        {Header: 'Role/Responsibility', accessor: 'Responsibility', Cell: ({value}: any) => <DefaultCell value = {value} tooltip = {true}/> },
        {Header: 'Frequency', accessor: 'Frequency', Cell: ({value}: any) => <DefaultCell value = {value} tooltip = {true}/> },
        {Header: 'Actions', accessor: 'Actions', Cell: ({value}: any) => <ActionsCell actions={value} />, disableSortBy: true }
    ];

    if (isConsolidated) {
        columns.splice(3, 0, {Header: 'Source Scorecard', accessor: 'SourceScorecard', Cell: ({value}: any) => <DefaultCell value = {value ?? <i>None</i>} tooltip = {true}/>, disableSortBy: true});
    }

    if (dataObject !== undefined && dataObject.length > 0) {
        const rows = dataObject.map((item: EEMonitoringProgress.DtoIn) => ({
            Id: item.id,
            Stakeholder: DataTableHtmlFormatter(item.stakeholder, ' '),
            Responsibility: DataTableHtmlFormatter(item.responsibility, ' '),
            Frequency: DataTableHtmlFormatter(item.frequency, ' '),
            SourceScorecard: item.sourceScorecardName ?? null,
            Actions: [
                { label: 'View/Edit', action: handleEdit, key: item.id, icon: { color: 'info', name: 'edit' } },
                { label: 'Delete', action: handleDelete, key: item.id, icon: { color: 'error', name: 'delete' } }
            ]
        }));
        
        return { columns: columns, rows: rows };
    }
    else {
        return { columns: columns, rows: [] };
    }
}


